/**
 * RequireAuth — route guard for authenticated pages.
 *
 * Rules:
 *  1. No accessToken → redirect to /login (replace history so back button
 *     doesn't re-enter the protected page).
 *  2. Authenticated but mustChangePassword → force to /change-password
 *     unless already there.
 *  3. Otherwise render children.
 */
import { Navigate, useLocation } from 'react-router';
import type { ReactNode } from 'react';
import { useAuthStore } from '@/store/authStore';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { accessToken, mustChangePassword } = useAuthStore();
  const location = useLocation();

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
}
